var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AiChannelIncludeList.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-55f00f2b\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AiChannelIncludeList.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/market/AiChannelIncludeList.vue
// module id = 1437
// module chunks = 8